import * as React from 'react';
import { AlunoModel, ProfessorComMonoEPreModel } from '../../../Store';
import {
  Card,
  CardTitle,
  CardContent,
  Input,
  withGrid,
  Button,
  TabComponent,
  TabPanel,
  ListItem,
  ListItemTitle,
  ListItemText,
  Modal,
} from '../../../Components';
import styled from 'styled-components';
import { media } from '../../../Themes';
import InserirMonografiaModal from './InserirMonografiaModal';

interface IDetalhesProfessorProps{
  professor: ProfessorComMonoEPreModel;
  alterarVagasPreProjeto: (id: number, vagas: number) => any;
  ativarOuDesativar: () => any;
  ativarOuDesativarMembroBanca: () => any;
  onInserirMonografia: (alunoId: number, professorId: number,  titulo: string) => any;
  alunosAtivos: AlunoModel[];
}

const Grid = withGrid(CardContent);
const CardContentGrid = styled(Grid)`
  grid-template-columns: repeat(12, 1fr);
  align-items: end;
`;

const InputGrid = styled(Input) <any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;
  height: 20px;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const ButtonGrid = styled(Button) <any>`
  max-width: fit-content;
  grid-column: ${p => p.gridColumn};
  margin-top: 28px;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const DetalhesProfessorCard: React.FC<IDetalhesProfessorProps> = 
({ professor,alterarVagasPreProjeto,ativarOuDesativar,
  ativarOuDesativarMembroBanca,onInserirMonografia, alunosAtivos }: IDetalhesProfessorProps) => {
  const [professorAtivo, setProfessorAtivo] = React.useState(professor.professor.ativo);
  const [ativoMembroBanca, setAtivoMembroBanca] = React.useState(professor.professor.ativoBanca);
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    setProfessorAtivo(professor.professor.ativo)
    setAtivoMembroBanca(professor.professor.ativoBanca)
  })

  
  const tabRef = React.useRef<TabComponent>(null)

  const [ano, setAno] = React.useState<number>(0)

  const [vagasPreProjeto, setVagas] = React.useState(professor.professor.vagasPreProjeto);

  const downloadCSV = () => {
    var profId = professor.professor.id
    const tipoDaLista = tabRef.current!.state.activeChild === 'Monografias' ? 'csvmonografias' : 'csvpreprojetos'

    const urlDownload = `${process.env.REACT_APP_API_URL}arquivo/${tipoDaLista}?ProfessorId=${profId}&Ano=${ano | 0}`
    const link = document.createElement('a')
    link.href = urlDownload
    document.body.appendChild(link)
    link.click()
  }

  return (
    <>
      <Card>
        <CardTitle>{professor.professor.nome}</CardTitle>
        <CardContentGrid>
          <InputGrid
            gridColumn='1/6'
            value={professor.professor.email}
            label='E-mail'
            disabled={true}
          />
          <ButtonGrid
          gridColumn='8/12'
          color={professorAtivo ? 'errorColor' : 'approvedColor'}
          onClick={ativarOuDesativar}
        >{professorAtivo ? 'DESATIVAR PROFESSOR' : 'ATIVAR PROFESSOR'}
        </ButtonGrid>
        <ButtonGrid
          gridColumn='8/12'
          color={ativoMembroBanca ? 'errorColor' : 'approvedColor'}
          onClick={ativarOuDesativarMembroBanca}
        >{ativoMembroBanca ? 'DESATIVAR COMO MEMBRO' : 'ATIVAR COMO MEMBRO'}
        </ButtonGrid>
          <InputGrid
            gridColumn='1/2'
            value={ano != 0 ? ano : ''}
            label={`Ano (Ex.: 2021)`}
            type='number'
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAno(parseInt(e.target.value))}
          />
          <ButtonGrid
            gridColumn='2/7'
            onClick={downloadCSV}
          >
            Exportar Lista
          </ButtonGrid>
          <InputGrid
            gridColumn='1/2'
            value={vagasPreProjeto != null ? vagasPreProjeto:0} 
            label={`adicionar vagas para pré-projeto (Ex.: 2)`}
            type='number'
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setVagas(parseInt(e.target.value))}
          />
          <ButtonGrid
            gridColumn='2/7'
            onClick={()=>{alterarVagasPreProjeto(professor.professor.id,vagasPreProjeto)}}
          >
            Alterar
          </ButtonGrid>
          <ButtonGrid
            gridColumn='1/3'
            onClick={()=>setOpen(true)}
          >
            Atribuir Monografia
          </ButtonGrid>
        </CardContentGrid>
      </Card>
      {professor &&
        <Modal 
          size={"large"} 
          isVisible={open} 
          outterClick={()=>setOpen(false)}>
          <InserirMonografiaModal 
            professor={professor.professor}
            alunosAtivos={alunosAtivos}
            onInserirMonografia={onInserirMonografia}
          />
      </Modal>
      }
      <Card>
        <TabComponent activeChild='Monografias' ref={tabRef} >
          <TabPanel titulo='Monografias'>
            {professor.monografias.length != 0
              ? professor.monografias.map((m, i) => (
                <ListItem key={i} >
                  <ListItemTitle>{m.aluno && `${m.aluno.nome} - ${m.aluno.matricula}`}</ListItemTitle>
                  <ListItemText>{m.titulo}</ListItemText>
                </ListItem>
              ))
              :
              <CardTitle>Professor sem Monografias</CardTitle>}
          </TabPanel>
          <TabPanel titulo='Pré-Projetos' >
            {professor.preProjetos.length != 0
              ? professor.preProjetos.map((m, i) => (
                <ListItem key={i}>
                  <ListItemTitle>{m.aluno && `${m.aluno.nome} - ${m.aluno.matricula}`}</ListItemTitle>
                  <ListItemText>{m.titulo}</ListItemText>
                </ListItem>
              ))
              :
              <CardTitle>Professor sem Pré-Projetos</CardTitle>}
          </TabPanel>
        </TabComponent>
      </Card>
    </>
  );
};

export default DetalhesProfessorCard;